import React, { useEffect, useState } from 'react';

// props: interval, onFinished()
function Countdown(props) {
  const { interval = 60, onFinished } = props;
  const calculateTimeLeft = () => {
    if (finished) {
      return 0;
    }
    const val = end - Math.floor(Date.now() / 1000);
    if (val <= 0) {
      setFinished(true);
      if (typeof onFinished === 'function') {
        onFinished();
      }
      return 0;
    }
    return val;
  };
  const [finished, setFinished] = useState(false);
  const [end] = useState(Math.floor(Date.now() / 1000) + interval);
  const [counter, setCounter] = useState(calculateTimeLeft());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCounter(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(intervalId);
  });

  return (
    <span>
      {finished ? ('now') : (`in ${counter} seconds`)}
    </span>
  );
}

export default Countdown;
